import Vue from 'vue'
import { HotTable } from '@handsontable/vue';
import 'handsontable/dist/handsontable.full.css';

Vue.component('hot-table',HotTable)